import Axios from 'axios';

export default {
    getTournamentsEvents(sport) {
        return Axios.get(`/api/liveinplay/sportfixtures/${sport}/tournamentsevents `)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(error);
        })
    }
}